import { FC } from 'react'
import { Link, Route, Routes } from 'react-router-dom'
import { Column, Row } from '../core/Components'
import { TopnavLogo } from '../core/Topnav'
import MusicContributorAgreement from './MusicContributorAgreement'
import PrivacyPolicy from './PrivacyPolicy'
import SoundPackLicenseCommercial from './SoundPackLicenseCommercial'
import SoundPackLicensePersonal from './SoundPackLicensePersonal'
import TermsOfService from './TermsOfService'

const Legal: FC = () => {
  const headerHeight = '50px'

  return (
    <Column css={{ width: '100vw', height: '100vh', overflow: 'hidden' }}>
      <Row css={{ marginLeft: '15px', flexBasis: headerHeight }} verticalCenter>
        <Link to="/">
          <TopnavLogo />
        </Link>
      </Row>
      <Routes>
        <Route path="/terms-of-service" element={<TermsOfService headerHeight={headerHeight} />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy headerHeight={headerHeight} />} />
        <Route
          path="/sound-pack-license-personal"
          element={<SoundPackLicensePersonal headerHeight={headerHeight} />}
        />
        <Route
          path="/sound-pack-license-commercial"
          element={<SoundPackLicenseCommercial headerHeight={headerHeight} />}
        />
        <Route
          path="/music-contributor-agreement"
          element={<MusicContributorAgreement headerHeight={headerHeight} />}
        />
      </Routes>
    </Column>
  )
}

export default Legal
